import React, { useContext } from "react";
import { Form, Formik } from "formik";
import { defaultValues } from "./default-values";
import { validationSchema } from "./validation-schema";
import { CUSTOMER, LEGAL_AGREEMENT, PAYMENT_METHOD } from "./field-names";
import CustomerDataForm from "../_sub-forms/customer-data/form";
import LegalAgreementForm from "../_sub-forms/legal-agreement/form";
import PaymentMethodForm from "../_sub-forms/payment-method/form";
import AuthContext from "../../../services/firebase/auth-context/provider";
import FormSubmit from "../common/submit";
import * as styles from "./form.module.css";
var MagazineBuyForm = function MagazineBuyForm(_ref) {
    var submitButtonText = _ref.submitButtonText, onSubmit = _ref.onSubmit;
    var _useContext$ = useContext(AuthContext)[0], user = _useContext$.user, authenticated = _useContext$.authenticated; // Set default values
    if (authenticated && user.email)
        defaultValues[CUSTOMER].email = user.email;
    return /*#__PURE__*/ React.createElement(Formik, {
        onSubmit: onSubmit,
        initialValues: defaultValues,
        validationSchema: validationSchema
    }, function (props) {
        return /*#__PURE__*/ React.createElement(Form, null, /*#__PURE__*/ React.createElement("div", {
            className: styles.section
        }, /*#__PURE__*/ React.createElement("h3", {
            className: styles.sectionTitle
        }, "Pers\xF6nliche Daten"), /*#__PURE__*/ React.createElement(CustomerDataForm, {
            namespace: CUSTOMER,
            hideEmailField: authenticated && !!user.email,
            fieldValues: props.values[CUSTOMER]
        })), /*#__PURE__*/ React.createElement("div", {
            className: styles.section
        }, /*#__PURE__*/ React.createElement("h3", {
            className: styles.sectionTitle
        }, "Zahlungsart"), /*#__PURE__*/ React.createElement(PaymentMethodForm, {
            namespace: PAYMENT_METHOD,
            fieldValues: props.values[PAYMENT_METHOD]
        })), /*#__PURE__*/ React.createElement("div", {
            className: styles.section
        }, /*#__PURE__*/ React.createElement("h3", {
            className: styles.sectionTitle
        }, "AGB und Datenschutzverarbeitung"), /*#__PURE__*/ React.createElement(LegalAgreementForm, {
            namespace: LEGAL_AGREEMENT
        })), /*#__PURE__*/ React.createElement("div", {
            className: "text-center mb-2"
        }, /*#__PURE__*/ React.createElement(FormSubmit, {
            text: submitButtonText,
            props: props,
            buttonClassName: "btn-makroPurple"
        })));
    });
};
export default MagazineBuyForm;
